import PropTypes from 'prop-types';

const TermsAndCondition = ({data}) => {
  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 p-4'}>
      
      <h1 className={'  md:text-4xl text-3xl my-6 text-primary-900 flex font-semibold w-full justify-center items-center font-instrument '}>
         Terms And Conditions
      </h1>
      <div className={'w-full max-w-5xl bg-primary-50 rounded-2xl shadow-lg p-6 lg:p-10'}>
        <p className={'p-4 md:text-lg text-base font-medium text-[#2b3641] leading-relaxed'}>
          Welcome to <b className={'underline'}>Kalapi Stores</b>  (“Company”, “we”, “us”, or “our”). These Terms & Conditions (“Terms”) govern your access to and use of our website and services. By accessing or using this Website, you agree to be legally bound by these Terms.
          <br /> If you do not agree with any part of these Terms, please do not use the Website.
        </p>
        {/* <p  className={'md:text-[16px] p-6 lg:p-10 text-base text-gray-700 text-[#2b3641] font-medium leading-relaxed'}>If you do not agree with any part of these Terms, please do not use the Website.
        </p> */}
        <ul className={'list-disc md:p-6 p-2'}>
          {data.terms.map((items, index) => (
            <li key={index} className={'mb-4'}>
              <h2 className={'font-semibold md:text-xl text-base font-serif mb-1'}>{items.term}</h2>
              <p className={'md:text-[16px] text-base text-gray-700 text-[#2b3641] font-medium leading-relaxed'}>{items.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TermsAndCondition.propTypes = {
  data: PropTypes.shape({
    terms: PropTypes.arrayOf(
      PropTypes.shape({
        term: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default TermsAndCondition;
